import { useTranslations } from 'next-intl';
import { ModalButtonFixed, ModalButtonSecondFixed, ModalButtonWrapperFixed } from './styles';

interface FilterBottomSectionProps {
  isApplyDisable: boolean;
  onClickApply: () => void;
  onClear: () => void;
}
const FilterBottomSection = ({
  isApplyDisable,
  onClickApply,
  onClear,
}: FilterBottomSectionProps) => {
  const t = useTranslations();
  return (
    <>
      <ModalButtonWrapperFixed>
        <ModalButtonFixed
          $isDisable={isApplyDisable}
          data-testid="apply-button"
          onClick={onClickApply}
        >
          {t('Apply')}
        </ModalButtonFixed>
        <ModalButtonSecondFixed data-testid="clear-button" onClick={onClear}>
          {t('Clear')}
        </ModalButtonSecondFixed>
      </ModalButtonWrapperFixed>
    </>
  );
};

export default FilterBottomSection;
